import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const NoVocal: React.FC<SVGIconProps> = ({ size = 20, color = '#939B9F', ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.667 7.319v2.264a2.917 2.917 0 0 0 4.627 2.363L6.667 7.319Zm5.29 5.29c-.552.439-1.316.724-2.374.724-1.432 0-2.326-.523-2.884-1.24-.582-.75-.866-1.8-.866-2.926v-.834H4.167v.834c0 1.373.341 2.823 1.217 3.949.763.982 1.884 1.653 3.366 1.835v.882h-2.5V17.5h6.667v-1.667h-2.5v-.882c1.11-.136 2.017-.548 2.724-1.158l-1.184-1.184Zm2.24-.117-1.245-1.245c.256-.615.381-1.33.381-2.08v-.834H15v.834c0 1.13-.232 2.314-.803 3.325Zm-1.883-1.883L6.697 4.992a2.917 2.917 0 0 1 5.803.425v4.166c0 .361-.066.707-.186 1.026Z"
      fill={color}
    />
    <path fill={color} d="m2.917 4.819 1.179-1.18 12.963 12.964-1.179 1.18z" />
  </BaseSvg>
);
